/**
 * @internal
 *
 * Use the `isFocusable` utility function to check whether an element can receive
 * focus.
 */
export function isFocusable(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  element: any,
) {
  if (element.tabIndex < 0 || element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href;
    case 'INPUT':
      return element.type !== 'hidden';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return element.tabIndex >= 0;
  }
}
